/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Version } from '@angular/core';
/**
 * @stable
 */
export var /** @type {?} */ VERSION = new Version('2.4.8');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/common/src/version.js
// module id = 726
// module chunks = 26